import { Link, Outlet } from "react-router";

import { Logo } from "../ui/logo";

export default function LegalLayout() {
  return (
    <div className="mx-auto flex min-h-dvh w-[calc(100%-2rem)] max-w-3xl flex-col sm:w-[calc(100%-3rem)]">
      <header className="flex h-20 items-center justify-between border-b">
        <Logo linkTo="/" />
        <Link
          className="text-muted-foreground underline-decoration text-sm hover:underline"
          to="/login"
        >
          Sign in
        </Link>
      </header>
      <main className="legal-copy flex-1 py-12 sm:py-16">
        <Outlet />
      </main>
    </div>
  );
}
